export default {
      id: "i-arrow-back-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-back",
      toString: function () {
        return this.url;
      }
    }